import { ORDER_TIME_OPTIONS } from '../../../../../modals/order-method/useOrderTimeOptions';
import { DropoffAction, ORDER_METHODS, RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  sections: {
    order_method: {
      titles: {
        [ORDER_METHODS.PICKUP]: 'Afhalen',
        [ORDER_METHODS.DELIVERY]: 'Bezorging',
        [ORDER_METHODS.ROOM_SERVICE]: {
          [RoomServiceLocationType.RoomService]: 'Roomservice',
          [RoomServiceLocationType.TableService]: 'Tafelservice',
        },
      },
    },
    delivery_info: {
      title: 'Bezorggegevens',
      on_arrival: 'Bij aankomst:',
    },
    customer_info: {
      title: 'Contact',
    },
    payment: {
      title: 'Betaling',
    },
    request_invoice: {
      title: 'Factuur aanvragen',
      form: {
        is_receipt_required: {
          label: 'Factuur aanvragen per e-mail',
        },
      },
    },
    location: {
      title: 'Winkeladres',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Bezorgadres',
      },
      [ORDER_METHODS.ROOM_SERVICE]: {
        title: 'Adres ter plaatse',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Afhaaladres',
      },
    },
    method: {
      title: 'Methode',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Bezorging',
      },
      [ORDER_METHODS.ROOM_SERVICE]: {
        title: 'Ter plaatse',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Afhalen',
      },
    },
    time: {
      title: 'Tijd',
      method: {
        [ORDER_TIME_OPTIONS.asap]: {
          title: 'Standaard {{time}} min, Vandaag',
        },
        [ORDER_TIME_OPTIONS.scheduled]: {
          title: 'Later inplannen',
        },
      },
    },
  },
  [RoomServiceLocationType.RoomService]: {
    details_label: 'Kamernummer',
  },
  [RoomServiceLocationType.TableService]: {
    details_label: 'Tafelnummer',
  },
  form: {
    dropoff_action: {
      options: {
        [DropoffAction.RingDoorBell]: 'Bel aan',
        [DropoffAction.Sms]: 'Neem bij aankomst contact met mij op via sms',
      },
    },
    doorbell_name: {
      placeholder: 'Naam deurbel (optioneel)',
    },
    company_name: {
      placeholder: 'Bedrijfsnaam (optioneel)',
    },
    customer_note: {
      placeholder: 'Bezorginstructies (optioneel)',
    },
    order_instructions: {
      placeholder: 'Voer bestelinstructies in...',
    },
  },
  buttons: {
    change: 'Wijzigen',
    edit: 'Bewerken',
    done: 'Klaar',
    add_delivery_note: '+ Bezorggegevens toevoegen',
    add_order_instructions: '+ Bestelinstructies toevoegen',
  },
  summary: {
    doorbell: 'Deurbel',
    company: 'Bedrijf',
    note: 'Opmerking',
    instructions: 'Instructies',
  },
};
